import { CascadingMsalAccountComponentInterop } from './CascadingMsalAccountComponentInterop';
export class CascadingMsalAccountComponentInteropFactory {
    createFromMsalAuthenticationContextWindowSingleton(dotNetMsalCascadingAuthenticationStateDotNetObject) {
        if (dotNetMsalCascadingAuthenticationStateDotNetObject) {
            const msalAuthenticationContextWindowSingleton = window.msalAuthenticationContextSingleton;
            if (msalAuthenticationContextWindowSingleton) {
                const result = new CascadingMsalAccountComponentInterop(dotNetMsalCascadingAuthenticationStateDotNetObject);
                msalAuthenticationContextWindowSingleton.setOnMsalActiveAccountChangedHandler(result);
                return result;
            }
            else {
                throw "window.authenticationContextSingleton is undefined. It must have been initialized before getting to this point.";
            }
        }
        else {
            throw "dotNetMsalCascadingAuthenticationState is undefined. It must have a value at this point.";
        }
    }
}
